import { makeStyles } from "@material-ui/core";

const MuiStylesBusinessProfile = makeStyles((theme) => ({
	"@keyframes slideUp": {
		from: {
			opacity: 0,
			transform: "translateY(40px)",
		},
		to: {
			opacity: 1,
			transform: "translateY(0)",
		},
	},
	container: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		minHeight: "100vh",
		backgroundColor: "#f5f5f5",
		position: "relative",
	},
	backgroundImage: {
		width: "100%",
		height: "450px",
		objectFit: "cover",
		position: "absolute",
		top: 0,
		left: 0,
		zIndex: 1,
		animation: "$slideUp 0.6s ease-out",
		[theme.breakpoints.down("sm")]: {
			height: "350px",
		},
	},
	profileCard: {
		background: "white",
		padding: "32px 24px",
		width: "100%",
		maxWidth: "600px",
		marginTop: "350px",
		position: "relative",
		zIndex: 2,
		boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.1)",
		minHeight: "calc(100vh - 350px)",
		animation: "$slideUp 0.7s ease-out",
		[theme.breakpoints.down("sm")]: {
			marginTop: "350px",
			padding: "24px 16px",
			minHeight: "calc(100vh - 350px)",
		},
	},
	avatarContainer: {
		display: "flex",
		justifyContent: "center",
		marginTop: "-82px",
		animation: "$slideUp 0.8s ease-out",
		[theme.breakpoints.down("sm")]: {
			marginTop: "-66px",
		},
	},
	avatar: {
		width: "100px",
		height: "100px",
		backgroundColor: "#8C1837",
		fontSize: "46px",
		fontWeight: 600,
	},
	businessName: {
		fontWeight: 700,
		textAlign: "center",
		marginTop: "16px",
		color: "#333",
		animation: "$slideUp 0.9s ease-out",
	},
	addressContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginTop: "8px",
		gap: "4px",
		cursor: "pointer",
		transition: "opacity 0.2s ease",
		textDecoration: "underline",
		cursor: "pointer",
		"&:hover": {
			opacity: 0.7,
		},
		animation: "$slideUp 1s ease-out",
	},
	addressText: {
		textAlign: "start",
		color: "#666",
		animation: "$slideUp 1s ease-out",
	},
	phoneText: {
		textAlign: "center",
		marginTop: "4px",
		color: "#666",
		animation: "$slideUp 1.1s ease-out",
	},
	contactButtons: {
		display: "flex",
		justifyContent: "center",
		gap: "16px",
		marginTop: "24px",
		flexWrap: "wrap",
		animation: "$slideUp 1.2s ease-out",
	},
	contactButton: {
		backgroundColor: "#5D4037",
		color: "#fff",
		width: "56px",
		height: "56px",
		"&:hover": {
			backgroundColor: "#4E342E",
		},
	},
	divider: {
		width: "100%",
		margin: "24px 0",
		animation: "$slideUp 1.3s ease-out",
	},
	sectionTitle: {
		fontWeight: 700,
		marginBottom: "16px",
		color: "#333",
		animation: "$slideUp 1.4s ease-out",
	},
	aboutText: {
		color: "#666",
		lineHeight: 1.2,
		animation: "$slideUp 1.5s ease-out",
	},
	portfolioSection: {
		width: "100%",
		textAlign: "left",
		marginTop: "32px",
		animation: "$slideUp 1.6s ease-out",
	},
	portfolioGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(2, 1fr)",
		gap: "12px",
		marginTop: "16px",
	},
	portfolioImage: {
		width: "100%",
		height: "200px",
		objectFit: "cover",
		borderRadius: "12px",
		cursor: "pointer",
		transition: "transform 0.2s ease",
		"&:hover": {
			transform: "scale(1.02)",
		},
		[theme.breakpoints.down("sm")]: {
			height: "150px",
		},
	},
	socialSection: {
		width: "100%",
		textAlign: "left",
		marginTop: "32px",
		paddingBottom: "32px",
		animation: "$slideUp 1.7s ease-out",
	},
	socialButtons: {
		display: "flex",
		justifyContent: "center",
		gap: "24px",
		marginTop: "16px",
		flexWrap: "nowrap",
		overflowX: "auto",
		paddingBottom: "4px",
		WebkitOverflowScrolling: "touch",
		"&::-webkit-scrollbar": {
			display: "none",
		},
		msOverflowStyle: "none",
		scrollbarWidth: "none",
		[theme.breakpoints.down("md")]: {
			gap: "16px",
		},
		[theme.breakpoints.down("sm")]: {
			gap: "12px",
		},
		[theme.breakpoints.down("xs")]: {
			gap: "8px",
		},
	},
	socialIconButton: {
		width: "60px",
		height: "60px",
		borderRadius: "50%",
		border: "none",
		cursor: "pointer",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
		flexShrink: 0,
		"&:hover $socialIcon": {
			transform: "scale(1.2)",
		},
		[theme.breakpoints.down("md")]: {
			width: "60px",
			height: "60px",
		},
		[theme.breakpoints.down("sm")]: {
			width: "60px",
			height: "60px",
		},
		[theme.breakpoints.down("xs")]: {
			width: "55px",
			height: "55px",
		},
	},
	socialIcon: {
		transition: "transform 0.2s ease",
		fontSize: "30px !important",
		[theme.breakpoints.down("md")]: {
			fontSize: "25px !important",
		},
		[theme.breakpoints.down("sm")]: {
			fontSize: "22px !important",
		},
		[theme.breakpoints.down("xs")]: {
			fontSize: "20px !important",
		},
	},
	instagramButton: {
		background: "#FF6B35",
	},
	tiktokButton: {
		background: "#000",
	},
	twitterButton: {
		background: "#1DA1F2",
	},
	facebookButton: {
		background: "#1877F2",
	},
	websiteButton: {
		background: "#25D366",
	},
	whatsappButton: {
		background: "#25D366",
	},
	backButton: {
		width: "40px",
		height: "40px",
		"&:hover": {
			backgroundColor: "rgba(255, 255, 255, 1)",
		},
	},
	scheduleButton: {
		"&:hover": {
			backgroundColor: "#303f9f",
		},
	},
	footer: {
		width: "100%",
		textAlign: "center",
		padding: "32px 24px",
		marginTop: "32px",
		color: "#999",
		fontSize: "14px",
		animation: "$slideUp 1.8s ease-out",
		borderTop: "1px solid #e0e0e0",
		[theme.breakpoints.down("sm")]: {
			padding: "24px 16px",
			fontSize: "12px",
		},
	},
}));

export default MuiStylesBusinessProfile;

